import type { LDContext } from "launchdarkly-js-client-sdk";
import type { IUser } from "@/types/user";
import type { IWorkspace } from "@/types/workspace";

export function buildContext(user: IUser, workspace: IWorkspace | undefined): LDContext {
  const userCtx = {
    kind: "user" as const,
    key: user.id,
    email: user.email,
    name: [user.first_name, user.last_name].filter(Boolean).join(" ") || user.username,
    username: user.username,
    timezone: user.user_timezone ?? undefined,
  };

  if (!workspace) return userCtx;

  return {
    kind: "multi",
    user: userCtx,
    workspace: {
      key: workspace.id,
      name: workspace.name,
      slug: workspace.slug,
      organization_size: workspace.organization_size ?? undefined,
      currency: workspace.currency,
    },
  };
}
